import { render, staticRenderFns } from "./poses.vue?vue&type=template&id=bfbab350&scoped=true&"
import script from "./poses.vue?vue&type=script&lang=js&"
export * from "./poses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbab350",
  null
  
)

export default component.exports